import React from "react";
import { useNavigate } from "react-router-dom";
import { isSelected, isChildSelected } from "../helpers";
import { Logger } from "@base-provider";
import env from "env";
import MenuItem from "./menuItem";
import FooterItem from "./footerItem";
import SFTypography from "../../typography";

const RouteItem = ({ isFooter, route, selectedRoute, menuState, navigate }) => {
  // Determine which component to use based on the route type.
  // FooterItem: help...
  // MenuItem: Home, Benchmark, Content Studio, etc...
  const MenuComponent = isFooter ? FooterItem : MenuItem;

  return (
    <MenuComponent
      devOnly={route.devOnly}
      selected={
        (!route.children && isSelected(selectedRoute, route.path)) ||
        isChildSelected(selectedRoute, route.path)
      }
      onClick={() => route.path !== undefined && navigate(route.path)}
      label={<SFTypography variant="leftNav">{route.label}</SFTypography>}
      icon={route.icon}
      {...(route.children && {
        "aria-expanded":
          menuState[route.path] ||
          route.children.filter((x) => menuState[x.path]).length > 0,
      })}
    />
  );
};

const MenuItems = ({ filteredRoutes, menuState, selectedRoute, isFooter }) => {
  const navigate = useNavigate();

  if (!filteredRoutes) return null;

  Logger.of("App.Core.SideMenu.MenuItems").info({
    filteredRoutes,
    selectedRoute,
    menuState,
  });

  return (
    <>
      {filteredRoutes
        .filter((a) => !a.devOnly || (a.devOnly && env.REACT_APP_DEVELOPMENT))
        .map((route) => (
          <React.Fragment key={route.path}>
            <RouteItem
              isFooter={isFooter}
              route={route}
              selectedRoute={selectedRoute}
              menuState={menuState}
              navigate={navigate}
            />
          </React.Fragment>
        ))}
    </>
  );
};

export default MenuItems;
